import React from 'react';
import { styled } from 'baseui';
import type { StyleObject } from 'styletron-react';
import { SceneRender } from './components/scene-render'; // uses above component in same directory

var id = new Date().getTime() / 1000;
export type GlbRenderPropsT = {
  url: string;
  styles?: StyleObject;
};
const GlbRenderWrapper = styled('div', {
  width: '100%'
});
export const GlbRender = ({
  url,
  styles = {}
}: GlbRenderPropsT) => {
  return <GlbRenderWrapper>
      <SceneRender antialias id={`my-canvas${id}`} url={url} styles={styles} />
    </GlbRenderWrapper>;
};